import { ListSubheader as MuiListSubheader } from '@mui/material';
import type { ListSubheaderProps as MuiListSubheaderProps } from '@mui/material/ListSubheader';

export type ListSubheaderProps = MuiListSubheaderProps;

export const ListSubheader = ({ ...rest }: ListSubheaderProps): JSX.Element => (
  <MuiListSubheader {...rest} />
);
